module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-right-4.63dc4046.png";